import { z } from 'zod';
export const SHIFT_UNIT_TYPES = ['place', 'orgUnit'] as const;

/** work-schedule 一覧（拠点 / 組織ユニット単位のシフト一覧）の検索パラメータ。 */
export const WorkScheduleSearchSchema = z.object({
  /** 行の単位種別。place=店舗 / orgUnit=エリア。テーブルの表示レコードを切り替える。 */
  unitType: z.enum(SHIFT_UNIT_TYPES).default('place'),
  /** 表示対象の年（未指定はデモ基準月）。 */
  year: z.coerce.number().optional(),
  /** 表示対象の月（1-12、未指定はデモ基準月）。 */
  month: z.coerce.number().optional(),
  pageIndex: z.coerce.number().default(0),
  pageSize: z.coerce.number().default(50)
});
export type WorkScheduleSearchParams = z.infer<typeof WorkScheduleSearchSchema>;